import React, { useRef } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import CaptivatingFact from "./captivatingFact"

const CaptivatingFactSlider = ({blok}) => {

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }

  const settings = {
    autoplay: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <>
      <style>
        {`
          .captivating-fact-slider-section .slick-arrow {
              display: none !important;
          }
        `}
      </style>

      <div className="captivating-fact-slider-section">
        <div className="flex justify-around">
          <h3 className="text-lg font-bold mt-2 mb-4 underline-yellow">
            {/* <img className="w-[22px] h-[35px] inline-block mr-2" src="/icons/captivating-facts-double-exclamation.svg" alt=""/> */}
            {blok.factItemsTitle}
          </h3>
          <div className="flex justify-center gap-2 mb-4">
            <button className="button slick-arrow-mobile block" onClick={previous}>
              <img className="w-12 rotate-180" src="/icons/carousel-arrow-right.svg" alt="Prev button"/>
              <div className="text-xs">Go back</div>
            </button>
            <button className="button slick-arrow-mobile block" onClick={next}>
              <img className="w-12" src="/icons/carousel-arrow-right.svg" alt="Next button"/>
              <div className="text-xs">Next</div>
            </button>
          </div>
        </div>

        <div className="slider-container">
          <Slider ref={sliderRef} {...settings} >{blok.factItems?.map(factItem => (<CaptivatingFact blok={factItem} key={factItem._uid}/>))}</Slider>
        </div>
      </div>
    </>
  )

}

export default CaptivatingFactSlider
